import styled from "styled-components";
import { apolloSpaceInline1X, apolloSpaceInline2X, apolloSpaceInlineHalfX } from "@nexthink/apollo-tokens";
import Tooltip from "../tooltip/Tooltip";
import { StyledContent } from "../tooltip/Tooltip.style";
import { StyledActionBarButton } from "../action-bar/ActionBarButton.style";
import { StyledActionBarTitle } from "../action-bar/ActionBar.style";
import { StyledActionMenuItem, StyledActionMenuItemContainer, StyledExtra } from "../menu/ActionMenuItem.style";
import { Flex } from "../box";
import { StyledButtonIcon } from "../button-icon/ButtonIcon.style";
const ACTION_BAR_HEIGHT = "32px";
export const StyledTableActionBarContainer = styled.div.withConfig({ displayName: "StyledTableActionBarContainer_APC-7311-productShell", componentId: "sc-10j7kfn" })({
    height: ACTION_BAR_HEIGHT,
});
export const StyledTableActionBar = styled(Tooltip).withConfig({ displayName: "StyledTableActionBar_APC-7311-productShell", componentId: "sc-1ezau89" })(({ theme }) => ({
    [`& ${StyledContent}`]: {
        padding: 0,
        display: "flex",
        alignItems: "center",
    },
    [`& ${StyledActionBarButton}`]: {
        padding: `0 ${apolloSpaceInline2X}`,
    },
    [`& ${StyledActionBarTitle}`]: {
        whiteSpace: "nowrap",
        paddingRight: 0,
    },
    [`& ${StyledActionBarButton}, & ${StyledActionMenuItemContainer}`]: {
        position: "relative",
    },
    [`& ${StyledActionMenuItem}`]: {
        padding: `${apolloSpaceInlineHalfX} ${apolloSpaceInline2X}`,
    },
    [`${StyledActionMenuItemContainer}`]: {
        [`&:has(${StyledActionMenuItem}):has(:focus-visible)`]: {
            outline: `1px solid ${theme.colors.apolloColorStrokePopoverFocus}`,
            outlineOffset: "-1px",
        },
        [`${StyledExtra}`]: {
            display: "none",
        },
    },
}));
export const StyledKebabButton = styled.div.withConfig({ displayName: "StyledKebabButton_APC-7311-productShell", componentId: "sc-hpbci2" })(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    [`${StyledButtonIcon}`]: {
        color: theme.colors.apolloColorTextPopoverPrimary,
        margin: apolloSpaceInline1X,
        "&:focus-visible": {
            // overrides default blue focus outline
            outline: `1px solid ${theme.colors.apolloColorStrokePopoverFocus} !important`,
        },
    },
}));
export const StyledActionsContainer = styled(Flex).withConfig({ displayName: "StyledActionsContainer_APC-7311-productShell", componentId: "sc-165zp2y" })(({ theme }) => ({
    position: "relative",
    borderRight: `1px solid ${theme.colors.apolloColorStrokePopoverSeparator}`,
    borderLeft: `1px solid ${theme.colors.apolloColorStrokePopoverSeparator}`,
    // partial items separator
    "& > :before": {
        position: "absolute",
        width: "1px",
        content: '""',
        backgroundColor: theme.colors.apolloColorStrokePopoverSeparator,
        top: apolloSpaceInline1X,
        bottom: apolloSpaceInline1X,
        right: 0,
    },
    // to prevent the separator from appearing on the top of a focus border or hover style
    "& > :focus-within:before, & > :hover:before, & > :last-child:before": {
        opacity: 0,
    },
}));
//# sourceMappingURL=TableActionBar.style.js.map